import React, { useState } from "react";
import { setDoc, doc } from "firebase/firestore";
import { auth, firestore } from "../firebase";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@material-ui/core";
import "./Signup.css";
import ReCaptcha from "./ReCaptcha";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import Cookies from 'js-cookie';
import DOMPurify from 'dompurify';

function Signup() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompany] = useState("");
  const [designation, setDesignation] = useState("");
  const [location, setLocation] = useState("");
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  
  const sanitizeInput = (input) => {
    if (!input) return '';
    return DOMPurify.sanitize(input).trim();
  };
  const handleRecaptchaVerify = (value) => {
    setRecaptchaValue(value);
  };

  async function handleSaveProfile() {
    const userId = sessionStorage.getItem("userId");
    if (!recaptchaValue || !userId) {
      alert("Please complete the ReCaptcha and ensure you are logged in.");
      return;
    }

    try {
      const tenantId = uuidv4();
      const roles = ["user"];

      const sanitizedData = {
        name: sanitizeInput(name),
        email: sanitizeInput(sessionStorage.getItem("email")),
        mobile: sanitizeInput(mobile),
        company: sanitizeInput(company),
        designation: sanitizeInput(designation),
        location: sanitizeInput(location),
      };

      await setDoc(doc(firestore, "userprofilemaster", userId), {
        ...sanitizedData,
        tenantId,
        roles,
      });

      const response = await axios.post('https://user-management-api-v1.onrender.com/api/auth/login', {
        email: sessionStorage.getItem("email"),
        tenantId,
        userRole: roles[0],
      });

      if (response.data && response.data.token) {
        const { token } = response.data;
        Cookies.set('jwtToken', token, {
          expires: 1,
          secure: process.env.NODE_ENV === 'production',
          sameSite: 'strict',
          path: '/'
        });
        sessionStorage.removeItem("authToken");
        navigate("/");
      } else {
        console.error("Token not found in response:", response.data);
        alert("Failed to retrieve token. Please try again.");
      }
    } catch (error) {
      console.error("Error saving profile or logging in:", error);
      alert("An error occurred while saving your profile or logging in. Please try again.");
    }
  }


  return (
    <div className="signup-container">
      <h2>Create Your Profile</h2>
      <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
      <TextField label="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} fullWidth />
      <TextField label="Company" value={company} onChange={(e) => setCompany(e.target.value)} fullWidth />
      <TextField label="Designation" value={designation} onChange={(e) => setDesignation(e.target.value)} fullWidth />
      <TextField label="Location" value={location} onChange={(e) => setLocation(e.target.value)} fullWidth />
      <Button
        onClick={handleSaveProfile}
        style={{ background: "#CFD9F3", marginTop: "20px" }}
      >
        Save Profile
      </Button>
      <ReCaptcha onVerify={handleRecaptchaVerify} />
    </div>
  );
}

export default Signup;